import { lazy, Suspense } from "react";
import { ErrorBoundary } from "../components/ErrorBoundary";

const UploadInbox = lazy(
  () => import("../modules/upload-inbox/components/UploadInbox")
);

export function UploadPage() {
  return (
    <ErrorBoundary fallback={<div style={{ padding: 24 }}>Upload Inbox failed to load.</div>}>
      <Suspense fallback={<div className="remote-loading"><p>Loading Upload Inbox...</p></div>}>
        <UploadInbox />
      </Suspense>
    </ErrorBoundary>
  );
}
